var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vinput',{ref:"vinput",attrs:{"value":_vm.value,"valuetype":'phone',"border":_vm.border,"error":_vm.error,"label":_vm.label,"input_event":true,"focus_area":_vm.focus_area,"placeholder":_vm.placeholder},on:{"input":_vm.set_phone,"keydown":_vm.keydown,"keyup":_vm.keyup,"focus":function($event){return _vm.$emit('focus')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }